import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { selectAIGenerationLimit } from 'services/store/user/selectors';
import ConversionDialog from 'components/Modals/ConversionDialog';

interface PropsType {
  isOpen: boolean;
  onClose: () => void;
}

const ProUserAIGenerationLimitDialog = ({ isOpen, onClose }: PropsType) => {
  const { t } = useTranslation();

  const aiGenerationLimit = useSelector(selectAIGenerationLimit);

  return (
    <ConversionDialog
      title={t('aiMusicGenerator:generationLimit:title')}
      description={t('aiMusicGenerator:generationLimit:descriptionPro', {
        daysToReset: aiGenerationLimit?.daysToDownloadLimitReset,
      })}
      submitText={t('aiMusicGenerator:generationLimit:ctaPro')}
      state={{
        isOpen,
        isLoading: false,
        error: null,
      }}
      action={{
        onClose,
        onSubmit: onClose,
        onExited: onClose,
      }}
    />
  );
};

export default ProUserAIGenerationLimitDialog;
